
import { defineComponent, ref } from "vue";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { get } from "tps.shared.ui/core/requestHelpers";
import axios from "axios";
import { Button as KButton } from "@progress/kendo-vue-buttons";

declare var $: any;
export default defineComponent({
  name: "UserLogisticsInfo",
  components: {
    KendoDdl: DropDownList,
    KButton,
  },
  setup() {
    const grid: any = ref(null);
    return {
      grid,
    };
  },
  data() {
    return {
      innerUsers: [] as any[],
      users: [] as any[],
      branches: [] as any[],
      productionBranchId: 0,
      deliveryBranchId: 0,
      suppressTrackingNotifications: false,
      isBusy: false,
      userId: 0,
      currentUser: null as any,
    };
  },
  computed: {
    isResetAvailable(): boolean {
      return this.deliveryBranchId > 0 || this.productionBranchId > 0;
    },
    isFormValid(): boolean {
      return (
        (this.deliveryBranchId == 0 && this.productionBranchId == 0) ||
        (this.deliveryBranchId != 0 && this.productionBranchId != 0)
      );
    },
  },
  async mounted() {
    const _w = window as any;
    const _this = this;
    if (!_w.uslogisticsselect) {
      _w.uslogisticsselect = function (e: any) {
        const id = this.dataItem(this.select()).Id;
        _this.doSelectUserAndLoadData(id);
      };
    }

    if (!_w.onUserLogisticsGridRequestEnd) {
      _w.onUserLogisticsGridRequestEnd = function (e: any) {
        console.log(e);
        if (e.type === "destroy" && e.response) {
          if (e.response[0].Id == this.userId) {
            // this.clearCurrentSelection();
          }
        }
      };
    }

    this.isBusy = true;
    try {
      await this.loadUsers();

      if (this.$state.global.branchDetails.length == 0)
        await this.$dispatch.global.loadBranchDetails(null);

      this.branches = this.$state.global.branchDetails;

      const grid = this.grid;
      await $.get("/form/grid/UserLogisticsInfoPartial", {}, (html: string) => {
        html = html.replace(/\/grid\//gi, "/form$&"); // fix up server url slug
        $(grid).html(html);
      });
    } finally {
      this.isBusy = false;
    }
  },
  methods: {
    usersListOptionTemplate(h: any, el: any, props: any) {
      const user = props.dataItem;
      return h(
        "li",
        {
          class: "user-ddl-option",
          // when using optins custom renderer, the items are not selected on click by some reason,
          // so doing that manually
          onClick: () => {
            this.doSelectUserAndLoadData(user.Id);
            $(".k-popup").hide();
          },
        },
        [h("span", `[${user.Email}]`), h("strong", user.FullName)],
      );
    },
    async loadUsers() {
      let { data } = await get(axios, "/grid/GetUserList?enforceWholeList=true", {
        prefix: "form",
      }) as { data: any[] };

      data.forEach(x => x.Combined = `[${x.Email}] ${x.FullName}`);

      this.innerUsers = data;
      this.users = data;
    },
    async onSaveClick() {
      if (!this.isFormValid) {
        alert('Production and delivery branches must either both be selected or both be unselected.');
        return;
      }

      this.isBusy = true;
      try {
        await axios.post("/form/grid/SetUserLogisticsInfo", {
          Id: this.userId,
          DeliveryBranchId: this.deliveryBranchId,
          ProductionBranchId: this.productionBranchId,
          SuppressTrackingNotifications: this.suppressTrackingNotifications,
        });

        await this.refreshGrid();
      } finally {
        this.isBusy = false;
      }
    },
    onReset() {
      this.deliveryBranchId = 0;
      this.productionBranchId = 0;
    },
    clearCurrentSelection() {
      this.currentUser = null;
      this.userId = 0;
      this.deliveryBranchId = 0;
      this.productionBranchId = 0;
      this.suppressTrackingNotifications = false;
    },
    async refreshGrid() {
      await $("#uslogistics").data("kendoGrid")?.dataSource.read();
    },
    async doSelectUserAndLoadData(userId: any) {
      this.isBusy = true;
      try {
        this.userId = userId;
        const user = this.users.find(u => u.Id === userId);
        this.currentUser = user;

        let { data } = await axios.post("/form/grid/GetUserLogisticsInfo?userId=" + userId) as { data: any };

        this.productionBranchId = data.ProductionBranchId;
        this.deliveryBranchId = data.DeliveryBranchId;
        this.suppressTrackingNotifications = data.SuppressTrackingNotifications;
      } finally {
        this.isBusy = false;
      }
    },
    async selectUser(evtData: any) {
      // console.log(evtData);
      // const userId = evtData.value?.Id;
      // await this.doSelectUserAndLoadData(userId);
    },
    filterChange(event: any) {
      this.users = this.filterData(event.filter);
    },
    filterData(filter: any) {
      const data = this.innerUsers.slice();
      return filterBy(data, filter);
    },
  },
});
